import { render } from "./CustomersTab.vue?vue&type=template&id=b53cd95c&ts=true"
import script from "./CustomersTab.vue?vue&type=script&lang=ts"
export * from "./CustomersTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__